import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingScreenService {

  constructor() { }

  private _loading: boolean = false;
  public isLoading = new BehaviorSubject(false);

  get loading(): boolean {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
    this.isLoading.next(value);
  }

  startLoading() {
    if (this.loading == false)
      this.loading = true;
  }

  stopLoading() {
    this.loading = false;
  }
}
